<!--
 * @FileDescription: 单一数据名称与数据或多个组合展示
 * @Author: 作者信息
 * @Date: 文件创建时间
 * @LastEditors: dcq
 * @LastEditTime: 2023-07-27 21:42:23
 -->
 
<template>
    <dv-border-box10 class="keyVal-template" :order="order" :keyValId="keyValId" :searchInformation="searchInformation">
        <div class="data-title">{{ title }}</div>
        <div class="key-val" v-for="nameVal in searchInformation" :key="nameVal.name">
            <div class="key-name">{{ nameVal.name }}</div>
            <div class="val-content">{{ nameVal.val }}</div>
        </div>
    </dv-border-box10>

    <dv-border-box12 class="url-keyVal" :order="order" :keyValId="keyValId">
        <el-carousel height="100%" class="url-carousel" ref="urlCarousel" indicator-position="none" :autoplay="false"  arrow="never">
            <el-carousel-item v-for="item in searchUrl" :key="item.properties.name">
                <div class="data-title">{{ urlTitle }}</div>
                <div class="key-val">
                    <div class="key-name">{{ item.properties.name }}</div>
                    <div class="val-content">{{ item.properties.website }}</div>
                </div>
            </el-carousel-item>
        </el-carousel>

    </dv-border-box12>
</template>

<script>
export default {
    name: 'KeyValTemplate',
    data() {
        return {
        }
    },
    mounted() {
    },
}
</script>


<script setup>
import { ref ,onMounted} from 'vue';
import { defineProps, watch } from 'vue';
import { BorderBox10 as DvBorderBox10 } from '@kjgl77/datav-vue3'
import { BorderBox12 as DvBorderBox12 } from '@kjgl77/datav-vue3'

import axios from 'axios';
// import {urlSearchData} from './schoolData'
// import activeJson from "@/components/activeChartData.json"

let props = defineProps({
    keyValId: String,
    order: String,
    title: String,
    searchInformation: Array,
    urlData: Array,
    urlTitle: String,
    searchSciIndex: Number
});
console.log("KeyValprops", props)

// let keyValList = refProps.nameValListAll._object.nameValListAll
// console.log("refProps", refProps.nameValListAll._object.nameValListAll);

// let keyValList = props.nameValListAll
// console.log("refProps", refProps.nameValListAll._object.nameValListAll);

// const order = props.order;

// let nameKeyValAll = window.parent.nameValListAll
// console.log("nameKeyValAll",nameKeyValAll);

// const searchUrl =  urlSearchData
// const searchUrl =  activeJson.searchSciPt.features

let urlCarousel = ref()
let activeJson=ref({})
let searchUrl = ref({})

onMounted(() => {
//   console.log(`the component is now mounted.`)
  axios.get('/activeChartData.json')
      .then(response => {
        activeJson.value= response.data;
        searchUrl.value=activeJson.value.searchSciPt.features
      })
      .catch(error => {
        console.log(error);
      });
})

watch(props,(newProps)=>{
    urlCarousel.value.setActiveItem(newProps.searchSciIndex - 1);
})

</script>


<style lang="scss">
$orders: 1, 2, 3, 4, 5, 6, 7, 8;

div.keyVal-template {
    position: absolute;
    z-index: 10;

    &[keyValId='1'] {
        margin-top: 1vh;
        margin-left: 1vw;
        width: 28vw;
        height: 12vh;

        div.border-box-content {
            width: 98%;
            // margin-left: 2%;
            column-gap: 5%;
        }

        div.data-title {
            // margin-top: 0.4vh;
            width: 28vw;
            line-height: 3vh;
            height: 3vh;
            font-size: 1vw;
            font-weight: 600;
            color: rgba(230, 242, 252, 0.9);
        }

        div.key-val {
            width: fit-content;
            height: 9vh;
            row-gap: 0vh;
            justify-content: center;
            // justify-content: flex-start;

            div.key-name {
                height: 4.5vh;
                line-height: 4.5vh;
                font-size: calc(0.3vh + 0.8vw);
                font-weight: 600;
                font-family: "Microsoft YaHei";
                text-align: right;
                color: rgb(246, 251, 255);
            }

            div.val-content {
                height: 4.5vh;
                line-height: 4.5vh;
                font-size: calc(0.3vh + 0.8vw);
                text-align: right;
                font-family: "Impact";
                color: rgb(97, 247, 255);
            }
        }
    }

    &[keyValId='2'] {
        margin-top: 1vh;
        margin-left: 1vw;
        width: 20vw;
        height: 12vh;

        div.border-box-content {
            width: 98%;
            // margin-left: 2%;
            column-gap: 9%;
        }

        div.data-title {
            // margin-top: 0.4vh;
            width: 28vw;
            line-height: 3vh;
            height: 3vh;
            font-size: 1vw;
            font-weight: 600;
            color: rgba(230, 242, 252, 0.9);
        }

        div.key-val {
            width: fit-content;
            height: fit-content;
            row-gap: 1vh;
            justify-content: flex-start;

            div.key-name {
                font-size: 1.8vh;
                font-weight: 600;
                font-family: "Microsoft YaHei";
                text-align: right;
                color: rgb(246, 251, 255);
            }

            div.val-content {
                font-size: 2.6vh;
                text-align: right;
                font-family: "Impact";
                color: rgb(181, 255, 97);
            }
        }
    }

    &[keyValId='3'] {
        margin-top: 3vh;
        // margin-left: 1vw;
        left: 0.5vw;
        width: 19vw;
        height: 12vh;

        div.border-box-content {
            width: 98%;
            height: 96%;
            margin-top: 1%;
            margin-bottom: 2%;
            margin-left: 1%;
            column-gap: 9%;
            border-radius: 10px;
            background-color: rgba(62, 97, 183, 0.2);
            backdrop-filter: blur(4px);
        }

        div.data-title {
            // margin-top: 0.4vh;
            width: 28vw;
            line-height: 3vh;
            height: 3vh;
            font-size: 1vw;
            font-weight: 600;
            color: rgba(230, 242, 252, 0.9);
        }

        div.key-val {
            width: fit-content;
            height: 9vh;
            row-gap: 0vh;
            justify-content: center;
            // justify-content: flex-start;

            div.key-name {
                height: 4.5vh;
                line-height: 4.5vh;
                font-size: calc(0.3vh + 0.8vw);
                font-weight: 600;
                font-family: "Microsoft YaHei";
                text-align: center;
                color: rgb(246, 251, 255);
            }

            div.val-content {
                height: 4.5vh;
                line-height: 4.5vh;
                font-size: calc(0.3vh + 0.8vw);
                text-align: center;
                font-family: "Impact";
                color: rgb(181, 255, 97);
            }
        }
    }

    @each $order in $orders {
        &[order='#{$order}'] {
            order: $order;
        }
    }

    div.border-box-content {
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        align-content: center;
    }


    div.data-title {
        position: relative;
        font-family: "Microsoft YaHei";
        text-align: center;
    }

    div.key-val {
        display: flex;
        flex-flow: column wrap;
        align-items: center;

        div.key-name {
            width: 100%;

        }

        div.val-content {
            width: 100%;
        }
    }
}

div.url-keyVal {
    position: absolute;
    z-index: 10;

    &[keyValId='1'] {
        margin-top: 1vh;
        margin-left: 1vw;
        width: 28vw;
        height: 12vh;

        div.border-box-content {
            width: 98%;
            // margin-left: 2%;
            column-gap: 5%;
        }

        div.data-title {
            // margin-top: 0.4vh;
            width: 28vw;
            line-height: 3vh;
            height: 3vh;
            font-size: 1vw;
            font-weight: 600;
            color: rgba(230, 242, 252, 0.9);
        }

        div.key-val {
            width: fit-content;
            height: fit-content;
            row-gap: 1vh;
            justify-content: flex-start;

            div.key-name {
                font-size: 1.8vh;
                font-weight: 600;
                font-family: "Microsoft YaHei";
                text-align: right;
                color: rgb(246, 251, 255);
            }

            div.val-content {
                font-size: 2.6vh;
                text-align: right;
                font-family: "Impact";
                color: rgb(97, 247, 255);
            }
        }
    }

    &[keyValId='2'] {
        margin-top: 1vh;
        margin-left: 1vw;
        width: 20vw;
        height: 12vh;

        div.border-box-content {
            width: 98%;
            // margin-left: 2%;
            column-gap: 9%;
        }

        div.data-title {
            // margin-top: 0.4vh;
            width: 28vw;
            line-height: 3vh;
            height: 3vh;
            font-size: 1vw;
            font-weight: 600;
            color: rgba(230, 242, 252, 0.9);
        }

        div.key-val {
            width: fit-content;
            height: fit-content;
            row-gap: 1vh;
            justify-content: flex-start;

            div.key-name {
                font-size: 1.8vh;
                font-weight: 600;
                font-family: "Microsoft YaHei";
                text-align: right;
                color: rgb(246, 251, 255);
            }

            div.val-content {
                font-size: 2.6vh;
                text-align: right;
                font-family: "Impact";
                color: rgb(181, 255, 97);
            }
        }
    }

    &[keyValId='3'] {
        position: absolute;
        margin-top: 1vh;
        // margin-left: 1vw;
        bottom: 5vh;
        left: 0.5vw;
        width: 19vw;
        height: 12vh;

        div.border-box-content {
            margin: 1% 1.5% 1.5% 1.5%;
            width: 97%;
            height: 94%;
            // margin-left: 2%;
            column-gap: 9%;
            border-radius: 8px;
            background-color: rgba(245, 250, 255, 0.1);
            backdrop-filter: blur(4px);
        }

        div.data-title {
            // margin-top: 0.4vh;
            width: 19vw;
            line-height: 3vh;
            height: 3vh;
            font-size: calc(0.3vh + 1.2vw);
            text-align: center;
            font-weight: 600;
            color: rgba(230, 242, 252, 0.9);
        }

        div.key-val {
            width: 19vw;
            height: 9vh;
            row-gap: 0vh;
            justify-content: center;

            div.key-name {
                height: 4.5vh;
                line-height: 4.5vh;
                font-size: calc(0.3vh + 0.8vw);
                font-weight: 600;
                font-family: "Microsoft YaHei";
                text-align: center;
                color: rgb(246, 251, 255);
            }

            div.val-content {
                height: 4.5vh;
                line-height: 4.5vh;
                font-size: calc(0.3vh + 1vw);
                text-align: center;
                font-family: "Impact";
                color: rgb(181, 255, 97);
                width: 17vw;
            }
        }
    }

    @each $order in $orders {
        &[order='#{$order}'] {
            order: $order;
        }
    }

    div.url-carousel {
        width: 19vw;
        height: 12vh;
        

        // div.border-box-content {
        //     display: flex;
        //     flex-flow: row wrap;
        //     justify-content: center;
        //     align-content: center;
        // }


        // div.data-title {
        //     position: relative;
        //     width: 19vw;
        //     font-family: "Microsoft YaHei";
        //     text-align: center;
        //     margin-top: 5px;
        // }

        // div.key-val {
        //     position: relative;
        //     display: flex;
        //     flex-flow: column wrap;
        //     flex-direction: row;
        //     align-items: center;

        //     div.key-name {
        //         width: 100%;
        //         text-align: center;
        //     }

        //     div.val-content {
        //         width: 18vw;
        //         height: 5vh;
        //         // margin-left: 1vw;
        //         text-align: center;

        //     }
        // }
    }

    // div.border-box-content {
    //     display: flex;
    //     flex-flow: row wrap;
    //     justify-content: center;
    //     align-content: center;
    // }


    // div.data-title {
    //     position: relative;
    //     font-family: "Microsoft YaHei";
    //     text-align: center;
    // }

    // div.key-val {
    //     display: flex;
    //     flex-flow: column wrap;
    //     align-items: center;

    //     div.key-name {
    //         width: 100%;

    //     }

    //     div.val-content {
    //         width: 100%;
    //     }
    // }
}

// div.url-keyVal {
//     position: absolute;
//     margin-top: 1vh;
//     margin-left: 1vw;
//     top: 15vh;
//     left: -0.5vw;
//     width: 19vw;
//     height: 12vh;
// }
</style>
